export interface IssueExternalCollaborationRequest {
  externalId: string
  userId: string
  registrationDate: string
  registrationBranchCode: string
}

export function IssueExternalCollaborationRequestToJSON(
  value: IssueExternalCollaborationRequest
): any {
  return {
    external_id: value.externalId !== '' ? value.externalId : undefined,
    user_id: value.userId !== '' ? value.userId : undefined,
    registration_date:
      value.registrationDate !== '' ? value.registrationDate : undefined,
    registration_branch_code:
      value.registrationBranchCode !== ''
        ? value.registrationBranchCode
        : undefined
  }
}
